import { atom } from "jotai";
import type { Resource, ResourceValues } from "@/lib/types";

export type ResourceState = {
  mode?: "create" | "edit";
  openSheet?: boolean;
  resource?: Resource;
  activeId?: string;
  healthAreaId?: string;
  dateTime?: Date;
  formData?: ResourceValues;
  loadingAI?: boolean;
};

export const healthAreaAtom = atom<ResourceState, [ResourceState], void>(
  {
    openSheet: false,
    mode: "create",
    resource: undefined,
    activeId: undefined,
    dateTime: undefined,
    formData: undefined,
    loadingAI: false,
  },
  (get, set, update: object) => {
    const current = get(healthAreaAtom);
    set(healthAreaAtom, { ...current, ...update });
  },
);

export const goalAtom = atom<ResourceState, [ResourceState], void>(
  {
    openSheet: false,
    mode: "create",
    resource: undefined,
    activeId: undefined,
    healthAreaId: undefined,
    dateTime: undefined,
    formData: undefined,
    loadingAI: false,
  },
  (get, set, update: object) => {
    const current = get(goalAtom);
    set(goalAtom, { ...current, ...update });
  },
);

export const routineAtom = atom<ResourceState, [ResourceState], void>(
  {
    openSheet: false,
    mode: "create",
    resource: undefined,
    activeId: undefined,
    healthAreaId: undefined,
    dateTime: undefined,
    formData: undefined,
    loadingAI: false,
  },
  (get, set, update: object) => {
    const current = get(routineAtom);
    set(routineAtom, { ...current, ...update });
  },
);
